import { useEffect, useState } from 'react';

const GAP = 16;

/**
 * Returns a right-margin (px) that keeps its element clear of HubSpot's
 * floating chat launcher, wherever HubSpot happens to render it (loads
 * asynchronously, can reposition). Never goes below `defaultMarginPx`, and
 * grows automatically if HubSpot's icon needs more clearance — works at any
 * resolution/screen size since it's based on the launcher's live position.
 */
export default function useHubspotSafeMargin(defaultMarginPx) {
  const [marginPx, setMarginPx] = useState(defaultMarginPx);

  useEffect(() => {
    const update = () => {
      const el = document.getElementById('hubspot-messages-iframe-container');
      if (!el) return;
      const { left, width } = el.getBoundingClientRect();
      if (!width) return;
      const required = Math.round(window.innerWidth - left + GAP);
      const next = Math.max(defaultMarginPx, required);
      setMarginPx((prev) => (Math.abs(prev - next) > 1 ? next : prev));
    };
    update();
    const intervalId = setInterval(update, 1000);
    window.addEventListener('resize', update);
    return () => {
      clearInterval(intervalId);
      window.removeEventListener('resize', update);
    };
  }, [defaultMarginPx]);

  return marginPx;
}
